import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import Swal from 'sweetalert2';



const alertAndConfirmation = (title = '', text = '', type = 'success') => {
  return Swal.fire({
    title: title,
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    text: text,
    icon: type
  });
};



export default props => {
  return (
    <Modal isOpen={props.isOpen}>
      <ModalHeader>
        {locales('titles.delete')} {props.itemGroupTitle}
      </ModalHeader>
      <ModalBody>{locales('messages.delete.confirm', { itemTitle: props.itemTitle })}</ModalBody>
      <ModalFooter>
        <a className="btn btn-danger btn-ok" onClick={() => {
          alertAndConfirmation('', locales('titles.deletedSuccessfully'), 'success')
          props.onConfirm()
        }}>
          {locales('labels.delete')}
        </a>
        <button type="button" className="btn" data-dismiss="modal" onClick={props.closeModal}>
          {locales('labels.cancel')}
        </button>
      </ModalFooter>
    </Modal>
  );
};
